'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppraisalConcludeController = function () {
  function AppraisalConcludeController(enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AppraisalConcludeController);
    this.enums = enums;

    this.getAppraisalQuality();
  }

  (0, _createClass3.default)(AppraisalConcludeController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getAppraisalQuality',
    value: function getAppraisalQuality() {
      this.appraisalQualityList = this.convertEnumToKeyValueList(this.enums.APPRAISAL_QUALITY);
      this.appraisalQualityList.unshift({ id: null, name: 'Please Select' });
    }
  }]);
  return AppraisalConcludeController;
}();

exports.default = AppraisalConcludeController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/appraisalConclude/appraisalConclude.controller.js